import { computed, inject, Injectable, Signal } from '@angular/core';
import {
  CONFIGURATION_SETTING_KEYS,
  ISortGroupWithTicketData,
  ISubscriptionTicket,
  ITicket,
  ICmsTicketOverviewItem,
} from '@web/dtos';
import { SortGroupsWithTicketDataStore } from '../api/sort-group-with-ticket-data/sort-groups-ticket-data.store';
import { CmsSubscriptionTicketService } from '../subscription/cms-subscription-ticket.service';
import { ConfigurationStore } from '../api/configuration/configuration-store.service';

@Injectable({ providedIn: 'root' })
export class CmsTicketOverviewService {
  private readonly sortGroupsWithTicketDataStore: SortGroupsWithTicketDataStore =
    inject(SortGroupsWithTicketDataStore);
  private readonly subscriptionTicketService: CmsSubscriptionTicketService =
    inject(CmsSubscriptionTicketService);
  private readonly configurationStore: ConfigurationStore =
    inject(ConfigurationStore);

  public readonly tickets: Signal<ICmsTicketOverviewItem[]> = computed(() => [
    ...this.sortGroupsWithTicketDataStore.sortGroups().map(
      (sortGroup: ISortGroupWithTicketData): ICmsTicketOverviewItem => ({
        id: sortGroup.externeReferenz ?? sortGroup.name,
        name: sortGroup.name,
        serviceAreaId: this.configurationStore.getNumberConfiguration(
          CONFIGURATION_SETTING_KEYS.ServiceAreaId
        ),
        ticketType: this.formatSortGroupType(sortGroup.sortengruppentyp),
        ticketData: sortGroup.ticketData,
        sortenExterneReferenzen: sortGroup.sortenExterneReferenzen,
        layoutAssignments: sortGroup.layoutAssignments,
      })
    ),
    ...this.subscriptionTicketService.subscriptions().map(
      (subscription: ISubscriptionTicket): ICmsTicketOverviewItem => ({
        id: subscription.guid,
        name: subscription.name,
        serviceAreaId: this.configurationStore.getNumberConfiguration(
          CONFIGURATION_SETTING_KEYS.SubscriptionServiceArea
        ),
        ticketType: 'Abonnement',
        ticketData: subscription.ticketData,
        sortenExterneReferenzen: [],
        layoutAssignments: [],
      })
    ),
  ]);

  public readonly isLoading: Signal<boolean> = computed(
    () =>
      this.sortGroupsWithTicketDataStore.isLoading() ||
      this.subscriptionTicketService.isLoading()
  );

  readonly hasLoaded = computed(
    () =>
      this.sortGroupsWithTicketDataStore.hasLoaded() ||
      this.subscriptionTicketService.hasLoaded()
  );
  readonly hasError = computed(
    () =>
      this.sortGroupsWithTicketDataStore.hasError() &&
      this.subscriptionTicketService.hasError()
  );

  public reloadTickets(): void {
    this.sortGroupsWithTicketDataStore.reloadSortGroups();
    this.subscriptionTicketService.reloadSubscriptions();
  }

  private formatSortGroupType(type: string): string {
    return type.replace(/^Verkaufssortengruppe/i, '');
  }
}
